// extracted by mini-css-extract-plugin
export var searchHeader = "_t-0";
export var searchHeaderDark = "_t-1";